import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import Card from './PostCard'

const ProjectPostList = props => (
  <StaticQuery
    query={query}
    render={ data => {
      const posts = data.allMarkdownRemark.edges.map(edge => ({
        ...edge.node.frontmatter
      })).filter(post => {
        if (props.ignorePaths && props.ignorePaths.length) {
          return props.ignorePaths.indexOf(post.path) === -1
        } else {
          return true
        }
      })
      return (
        <Root theme={props.theme} className={props.className}>
          <Main>
            <List>
              {posts.map((post, index) => (
                <Item key={index}><Card {...post} /></Item>
              ))}
            </List>
          </Main>
        </Root>
      )
    }}
  />
)

export default ThemeConsumer(ProjectPostList)

const Root = styled.div`
  position: relative;
`

const Main = styled.div``

const List = styled.ul`
  margin-top: -8px;
`

const Item = styled.li`
  margin-top: 8px;
`

export const query = graphql`
  {
    allMarkdownRemark (
      filter: { frontmatter: { postType: { eq: "project" } } }
      sort: { fields: [frontmatter___path], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            postType
            title
            path
            client
            clientType
            platforms
            stack
            shortDescription
            request
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
